import React,{useState}from 'react'
import { Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import { Btn, H4, H6, Image, P } from '../../../AbstractElements'
import { AlreadyHaveAnAccount, AuthSignIn, CreateYourPassword, DoneButton, Href, ResetYourPassword } from '../../../Constant'
import { Link } from 'react-router-dom'
import { dynamicImage } from '../../../Service/DynamicImage'

const ForgetPasswordContainer = () => {
  const [show,setShow]=useState(false)
  return (
      <Container fluid className="p-0">        
        <Row>
          <Col sm="12">     
            <div className="login-card login-dark">
              <div>
                <div><a className="logo" href="index.html">
                  <Image className="img-fluid for-light" src={dynamicImage("logo/logo_dark.png")} alt="looginpage"/>
                  <Image className="img-fluid for-dark" src={dynamicImage("logo/logo.png")} alt="looginpage"/></a></div>
                <div className="login-main"> 
                  <Form className="theme-form">
                    <H4>{ResetYourPassword}</H4>
                    <FormGroup>
                      <Label className='col-form-label'>Enter Your Mobile Number</Label>
                      <Row>
                        <Col sm="3" className="col-4"><Input type="text" value="+ 91"/></Col>
                        <Col sm="9" className="col-8"><Input className="mb-1" type="tel" value="000-000-0000"/></Col>
                        <Col sm="12"><div className="text-end"><Btn color='primary' className="btn-block m-t-10" type="submit">Send</Btn></div></Col>
                      </Row>
                    </FormGroup>
                    <div className="mt-4 mb-4">
                      <span className="reset-password-link">If don't receive OTP?  
                      <Link className="btn-link text-danger" to={Href}>Resend</Link></span></div>
                    <FormGroup>
                      <Label className="pt-0 col-form-label">Enter OTP</Label>
                      <Row>
                        <Col><Input className="text-center opt-text" type="text" value="00" max="2"/></Col>
                        <Col><Input className="text-center opt-text" type="text" value="00" max="2"/></Col>
                        <Col><Input className="text-center opt-text" type="text" value="00" max="2"/></Col>
                      </Row>
                    </FormGroup>
                    <H6 className="mt-4">{CreateYourPassword}</H6>
                    <FormGroup>
                      <Label className='col-form-label'>New Password</Label>
                      <div className="form-input position-relative">
                        <Input type={show ? "text" : "password"} required placeholder="*********"/>
                        <div className="show-hide" onClick={()=>setShow(!show)}><span className="show"></span></div>
                      </div>
                    </FormGroup>
                    <FormGroup>
                      <Label className='col-form-label'>Retype Password</Label>
                      <Input type="password" required placeholder="*********" autoComplete=''/>
                    </FormGroup>
                    <FormGroup className="mb-0">
                      <div className="checkbox p-0">
                        <Input id="checkbox1" type="checkbox"/>
                        <Label className="text-muted" htmlFor="checkbox1">Remember password</Label>
                      </div>
                      <Btn color='primary' className="btn-block w-100">{DoneButton}</Btn>
                    </FormGroup>
                    <P className="mt-4 mb-0 text-center">{AlreadyHaveAnAccount}<Link className="ms-2" to={`${process.env.PUBLIC_URL}/auth/login`}>{AuthSignIn}</Link></P>
                  </Form>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
  )
}

export default ForgetPasswordContainer